<template>
	<div id="ajaxTable">
		<b-row>
			<b-col md class="mb-2">
				<div class="mr-4">
					<span>{{ rowsMessage }}</span>
					<b-form-select
						size="sm"
						class="ml-2"
						id="perPageSelector"
						v-model="perPage"
						:options="perPageOptions"
						@change="updateTable"
					></b-form-select>
				</div>
			</b-col>
			<b-col md class="text-right">
				<b-row no-gutters>
					<b-col>
						<b-pagination
							v-model="currentPage"
							align="right"
							:total-rows="totalRows"
							:per-page="perPage"
							@change="updateTable"
						/>
					</b-col>
					<b-col cols="auto">
						<b-button
							class="ml-2"
							variant="primary"
							@click="() => $refs['table-columns'].show()"
							><md-icon icon="settings"
						/></b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<div class="d-flex flex-row align-items-center" v-if="showSelectAll">
			<div class="mr-4">
				<input type="checkbox" v-model="selectAll" />
				<span>Seleccionar todo</span>
			</div>
		</div>
		<b-table
			ref="table"
			hover
			:items="itemsReq"
			:fields="selectedColumnsObjs"
			:striped="striped"
			:bordered="bordered"
			:small="small"
			:responsive="responsive"
			empty-text="No se encontraron registros"
			v-bind="this.$attrs"
			v-on="this.$listeners"
			:sort-by.sync="sortByReal"
			:sort-desc.sync="sortDescReal"
			show-empty
		>
			<template v-if="showSelectAll" #cell(selected)="row">
				<b-form-group>
					<b-form-checkbox v-model="selected" :value="row.item.id" />
				</b-form-group>
			</template>
			<slot v-for="(_, name) in $slots" :name="name" :slot="name" />
			<template
				v-for="(_, name) in $scopedSlots"
				:slot="name"
				slot-scope="slotData"
				><slot :name="name" v-bind="slotData"
			/></template>
			<template v-slot:table-busy v-if="loading">
				<div id="busybox" class="text-center text-primary my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>Cargando...</strong>
				</div>
			</template>
			<template
				#empty
				v-if="
					permissionShow && !this.$hasPermission(this.permissionShow)
				"
			>
				<div class="text-center my-2">
					<h6>No tienes permisos de visualizacion</h6>
				</div>
			</template>
		</b-table>
		<b-modal
			title="Columnas de tabla"
			ref="table-columns"
			hide-footer
			ok-title="Guardar"
			size="sm"
		>
			<b-form-checkbox-group
				stacked
				v-model="selectedColumns"
				:options="columns"
				text-field="label"
				value-field="key"
			/>
		</b-modal>
	</div>
</template>

<script>
export default {
	props: {
		permissionShow: {
			type: String
		},
		responsive: {
			type: [Boolean, String]
		},
		rowDetails: {
			type: Boolean,
			required: false,
			default: true
		},
		selectedItems: {
			type: Array,
			required: false,
			default: () => []
		},
		items: {
			type: Array,
			required: false,
			default: () => []
		},
		striped: {
			type: Boolean,
			required: false,
			default: true
		},
		sortBy: {
			type: String,
			required: false,
			default: ""
		},
		sortDesc: {
			type: Boolean,
			required: false,
			default: false
		},
		bordered: {
			type: Boolean,
			required: false,
			default: true
		},
		small: {
			type: Boolean,
			required: false,
			default: true
		},
		columns: {
			type: Array,
			required: true
		},
		filters: {
			type: Object,
			required: false
		},
		resource: {
			type: String,
			required: true
		},
		actionViewModel: {
			type: Boolean,
			required: false,
			default: true
		},
		actionDeleteModel: {
			type: Boolean,
			required: false,
			default: true
		},
		itemsFilter: {
			type: Function,
			required: false,
			default: null
		},
		showSelectAll: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			selectedColumns: [],
			loading: true,
			perPage: 10,
			currentPage: 1,
			totalRows: 0,
			sortByReal: this.sortBy,
			sortDescReal: this.sortDesc,
			perPageOptions: [
				{ value: 10, text: 10 },
				{ value: 50, text: 50 },
				{ value: 100, text: 100 },
				{ value: 200, text: 200 },
				{ value: 500, text: 500 }
			],
			data: [],
			selectAll: false
		};
	},
	computed: {
		selectedColumnsObjs() {
			return this.columns.filter(
				column => this.selectedColumns.indexOf(column.key) !== -1
			);
		},
		offset() {
			return (this.currentPage - 1) * this.perPage;
		},
		rowsFrom() {
			return this.offset + 1;
		},
		rowsTo() {
			return Math.min(this.offset + this.perPage, this.totalRows);
		},
		rowsMessage() {
			return (
				"Mostrando " +
				this.rowsFrom +
				" a " +
				this.rowsTo +
				" registros de " +
				this.totalRows
			);
		},
		selected: {
			get() {
				return this.selectedItems;
			},
			set(val) {
				this.$emit("update:selectedItems", val);
			}
		}
	},
	methods: {
		itemsReq(ctx, callback) {

			if (this.permissionShow) {
				if (!this.$hasPermission(this.permissionShow)) {
					this.data = []
					callback([])
					return this.loading = false;
				}
			}
			this.loading = true;
			this.$root.api
				.get(`/${this.resource}`, {
					params: {
						limit: this.perPage,
						offset: this.offset,
						sortBy: ctx.sortBy,
						sortOrder: ctx.sortDesc ? "desc" : "asc",
						filters: this.filters
					}
				})
				.then(res => {
					this.loading = false;
					this.totalRows = res.data.totalRows;
					let aux = res.data.rows;
					if (this.itemsFilter !== null) aux = this.itemsFilter(aux);
					this.data = aux;
					callback(aux);
				})
				.catch(this.$root.handleRequestError);
		},
		updateTable() {
			this.$refs.table.refresh();
		},
		showMax() {
			this.perPage = 500;
			this.selectedColumns.push('selected')
			this.$refs.table.refresh();
		},
		loadUserPreferences() {
			this.selectedColumns = this.columns.map(col => col.key);
			try {
				let tableColumns = JSON.parse(
					sessionStorage.getItem(`table-${this.$el.id}-columns`)
				);
				if (tableColumns !== null) this.selectedColumns = tableColumns;
			} catch (e) {
				sessionStorage.removeItem(`table-${this.$el.id}-columns`);
			}
		}
	},
	mounted() {
		this.loadUserPreferences();
	},
	created() {},
	watch: {
		data: function(val) {
			this.$emit("update:items", [...val]);
		},
		sortByReal: function(val) {
			this.$emit("update:sortBy", val);
		},
		sortDesc: function(val) {
			this.$emit("update:sortDesc", val);
		},
		filters: function() {
			this.selected = [];
		},
		selectedColumns(val) {
			sessionStorage.setItem(
				`table-${this.$el.id}-columns`,
				JSON.stringify(val)
			);
		},
		selectAll: function(val) {
			if (val) {
				this.selected = [...this.data.map(item => item.id)];
			} else {
				this.selected = [];
			}
		}
	}
};
</script>

<style scoped>
#ajaxTable {
	clear: both;
}
.active {
	color: cornflowerblue;
}
#busybox {
	/*min-height: 400px;*/
}
#perPageSelector {
	width: 80px;
}
</style>
